module.exports = __webpack_public_path__ + "img/close-icon.15e2d1dd.svg";